import type {
	AnalyticsTransactionBasis,
	FinanceConsolidation,
	AnalyticsMarketplaceStats,
	AnalyticsPeriodKey,
	AnalyticsSeries,
	AnalyticsTransactionsPage,
} from "@expertloop/shared";
import { adminApi } from "../../services/api";

/** Nombre de transactions par page. Au-delà, le tableau cesse d'être lisible. */
export const FINANCE_PAGE_SIZE = 25;

/*
 * Appels de la page Finance.
 *
 * Les totaux et la liste des transactions viennent du même point d'entrée
 * analytique et de la même période : c'est ce qui garantit qu'une somme
 * affichée puisse être retrouvée dans le tableau qui la suit.
 */
export const financeApi = {
	marketplace: (period: AnalyticsPeriodKey) =>
		adminApi.get<AnalyticsMarketplaceStats>(`/admin/analytics/marketplace?period=${period}`),

	consolidation: (period: AnalyticsPeriodKey) =>
		adminApi.get<FinanceConsolidation>(`/admin/analytics/consolidation?period=${period}`),

	series: (period: AnalyticsPeriodKey) =>
		adminApi.get<AnalyticsSeries>(`/admin/analytics/series?period=${period}&metric=gmv`),

	transactions: (
		period: AnalyticsPeriodKey,
		currency: string | null,
		basis: AnalyticsTransactionBasis,
		page: number,
	) => {
		const query = new URLSearchParams({
			period,
			basis,
			page: String(page),
			pageSize: String(FINANCE_PAGE_SIZE),
		});
		if (currency) {
			query.set("currency", currency);
		}
		return adminApi.get<AnalyticsTransactionsPage>(`/admin/analytics/transactions?${query.toString()}`);
	},
};
